import { Platform, Dimensions } from "react-native";

export const { width: deviceWidth, height: deviceHeight } =
  Dimensions.get("window");

export const isIOS = Platform.OS === "ios";
export const isAndroid = Platform.OS === "android";
export const isWeb = Platform.OS === "web";

export const isSmallDevice = deviceWidth < 360;

export const getDeviceDimensions = () => {
  return { deviceWidth, deviceHeight };
};

export const isTablet = deviceWidth >= 768; // Basic heuristic, customize for your needs
